// Auto-generated from compiled_styleguide.json
// Do not edit directly - modify source JSON5 files instead

export const pattern_config = {
	"sticky_scroll": {
		"layout_switch": "b5"
	},
	"jump_nav": {
		"layout_switch": "b4"
	},
	"masthead": {
		"layout_switch_show_cta": "b3",
		"layout_switch_desktop_1": "b6",
		"layout_switch_desktop_2": "b7",
		"is_megamenu_behind_masthead": false
	},
	"hero": {
		"layout_switch": "b4"
	},
	"pullquote": {
		"layout_switch": "b5"
	},
	"tab_group": {
		"layout_switch_after_tabs": "b2",
		"layout_switch_non_scrollable": "b4",
		"layout_switch_tabs_and_after_aligned": "b5"
	},
	"sidebar": {
		"layout_switch_1": "b7",
		"layout_switch_2": "b8",
		"header_gap": "24px"
	},
	"site_logo": {
		"ratio_masthead": 4.92,
		"width_masthead_unstuck": "96px 246px",
		"width_masthead_stuck": "80px 96px",
		"ratio_footer": 4.92,
		"width_footer": "262px 292px",
		"offset_y_masthead_unstuck": "0px",
		"offset_y_masthead_stuck": "11px 11px"
	},
	"filter": {
		"layout_switch_2": "b5"
	},
	"reveal": {
		"bp_small": "b3",
		"bp_medium": "b5",
		"bp_large": "b7"
	},
	"slideshow": {
		"swiper_speed": 360,
		"caption_transition": 480
	},
	"feed": {
		"bp_featured_layout_1": "b5",
		"bp_featured_layout_2": "b6"
	},
	"event_card": {
		"v1_horizontal": "b3",
		"v1_image_balanced": "b5",
		"v2_horizontal": "b4",
		"v2_image_visible": "b6"
	},
	"post_card": {
		"v1_horizontal": "b3",
		"v1_image_balanced": "b5",
		"v2_horizontal": "b2",
		"v2_text_dominant": "b3",
		"v2_split_footer": "b4",
		"v3_horizontal": "b3",
		"v3_compact": "b4"
	}
};

export default pattern_config;
